import { Controller, useFormContext } from "react-hook-form";
import { Grid, IconButton, InputAdornment, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const Input = ({name, label, type = "text", size = 12, min = 3, max = 250, val='', regEx = /[A-Z,. ÁÉÓÚÍÑ]/ig, disabled = false, handleShowPassword = null}) => {
    const { control } = useFormContext();
    return(
        <Grid item xs={12} sm={12} md={size}>
            <Controller
                name={name}
                control={control}
                rules={{
                    required: 'Campo obligatorio',
                    minLength: { value: min, message: `Longitud minima ${min}` },
                    pattern: { value: regEx, message: `Hay valores no permitidos` },
                    maxLength: { value: max, message: `Longitud maxima ${max}` },
                }}
                defaultValue={val}
                render={({
                    field: { onChange, value },
                    fieldState: { invalid, error }
                }) => (
                    <TextField
                        error={invalid}
                        onChange={onChange}
                        defaultValue={val}
                        label={label}
                        disabled={disabled}
                        inputProps={{ maxLength: max }}
                        InputProps={
                            name === 'password' || name === 'confirm' || name === 'newPassword' ? {
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleShowPassword}>
                                            { type === 'password' ? <Visibility /> : <VisibilityOff /> }
                                        </IconButton>
                                    </InputAdornment>
                                )
                            } : null
                        }
                        autoComplete="off"
                        margin="normal"
                        type={type}
                        helperText={error && error.message}
                        fullWidth
                    />
                )}
            />
        </Grid>
    )
}

export default Input;